import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { Card, CardBody, Row, Col, Container } from "reactstrap";
import Box from "@mui/material/Box";

import BalanceOf from "../components/common/BalanceOf";

function Token() {
	const { tokenId } = useParams();
	const { contracts, tokens, users } = useSelector((state) => state.admin);

	const selectedToken = tokens.find((token) => token._id === tokenId);
	const selectedContract = contracts.find(
		(contract) => contract._id === selectedToken.contractId
	);
	const selectedUser = users.find((user) => user._id === selectedContract.user);

	const displayProps = [
		{
			header: "Contract",
			props: ["name", "address", "symbol"],
			data: selectedContract,
		},
		{
			header: "Token",
			props: ["name", "description", "royalties", "amount"],
			data: selectedToken,
		},
	];

	if (!selectedToken) {
		return <h1>Loading</h1>;
	}

	return (
		<Box sx={{ minHeight: "78vh", margin: "0 auto" }} maxWidth="md">
			<Card>
				<CardBody className="d-flex justify-content-between">
					<Container>
						<Row>
							<Col xs={6}>
								<Box
									sx={{
										width: "100%",
										height: "auto",
										borderRadius: "16px",
										boxShadow: "0 4px 24px 0 rgb(34 41 47 / 10%)",
									}}
									component="img"
									src={`${process.env.REACT_APP_IPFS_HOST}/${selectedToken.image}`}
								/>
							</Col>
							<Col xs={6}>
								{displayProps.map(({ header, props, data }) => (
									<Card className="overflow-hidden mb-3" key={header}>
										<h4 className="fw-bolder border-bottom py-1 px-3 mb-1">
											{header} details
										</h4>
										<table className="mt-2 mt-xl-0 w-100">
											<tbody>
												{props.map((prop) =>
													!data[prop] ||
													(prop === "amount" &&
														(selectedContract.type === "ERC721" ||
															selectedContract.type === "ERC721UPG")) ? null : (
														<tr key={prop}>
															<th className="w-50 py-1 px-3 text-capitalize">
																{prop}
															</th>
															<td className="py-1 px-3">
																{prop === "address" ? (
																	`${data.address.slice(
																		0,
																		5
																	)}...${data.address.slice(-6)}`
																) : prop === "amount" ? (
																	<>
																		<BalanceOf
																			contractAddress={selectedContract.address}
																			tokenID={selectedToken.tokenID}
																			accountAddress={selectedUser.account}
																		/>
																		<span>/{data[prop]}</span>
																	</>
																) : (
																	data[prop] || "No info"
																)}
															</td>
														</tr>
													)
												)}
											</tbody>
										</table>
									</Card>
								))}
							</Col>
						</Row>
					</Container>
				</CardBody>
			</Card>
		</Box>
	);
}

export default Token;
